import { render, staticRenderFns } from "./SyncToCooperationDetail.vue?vue&type=template&id=3ecb4546&scoped=true&"
import script from "./SyncToCooperationDetail.vue?vue&type=script&lang=js&"
export * from "./SyncToCooperationDetail.vue?vue&type=script&lang=js&"
import style0 from "./SyncToCooperationDetail.vue?vue&type=style&index=0&id=3ecb4546&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecb4546",
  null
  
)

export default component.exports